module.exports = __webpack_public_path__ + "img/perfection@2x.7f48e06.jpg";